import { GlobalAppState } from 'rdx/state';

export const selectSchedule = (state: GlobalAppState) => state.schedule.schedule;

export const selectScheduleRequestState = (state: GlobalAppState) => state.schedule.fetchingState;

export const selectScheduleUpdateRequestState = (state: GlobalAppState) =>
  state.schedule.updateRequestState;

export const selectScheduleUpdateError = (state: GlobalAppState) => state.schedule.error?.message;
